export default __webpack_public_path__ + "static/46-e7d05622ab5399785069fd03ef25d750.gif";